<p-panel>
	<app-reactive-form-builder
		#builderRef
		(formChanges)="formChanges($event[0], $event[1])"
		(goBack)="goBack()"
		[form]="form.formFields"
		[dropdownLoadTrigger]="dropdownLoadTrigger"
		[id]="getRegisterId()"
		[request]="request"
		[getRequest]="entidadesApi.EntidadesGET"
	>
	</app-reactive-form-builder>
</p-panel>
